import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';

import { useRestrictedModal } from '../../../../../../components/modal/useRestrictedModal';

import { SecondaryButton } from '../../../../../../components/button';

import { getParametersFromUrl } from '../../../../../../utils/url-utils/urlUtils';
import { buildSearchModalURL, transformCount } from '../../utils/utils';

type Props = {
  type: string;
  loggedIn: boolean;
  query: string;
  articleIds: string[];
  filterValue: string | { legislativeFolder: string };
  resultTotalHits: number;
  modal: string;
};

export const SeeMoreMessage: FC<Props> = ({
  type,
  loggedIn,
  query,
  articleIds,
  filterValue,
  resultTotalHits,
  modal,
}) => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const { openRestrictedModal } = useRestrictedModal();

  const onClick = () => {
    if (!loggedIn) {
      openRestrictedModal({ source: `${type}_see_more` });
      return;
    }
    const { version } = getParametersFromUrl(search);

    history.push({
      pathname,
      search: buildSearchModalURL({
        query,
        articleIds,
        type,
        filterValue,
        version,
        modal,
      }),
    });
  };

  return (
    <SecondaryButton onClick={onClick}>
      <FormattedMessage
        id="page/components/SearchQuerySection.tsx/1"
        values={{ number: transformCount(resultTotalHits) }}
      />
    </SecondaryButton>
  );
};
